import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=ef115a2c&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
import style0 from "./Help.vue?vue&type=style&index=0&id=ef115a2c&prod&lang=less&scoped=true"
import style1 from "./Help.vue?vue&type=style&index=1&id=ef115a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef115a2c",
  null
  
)

export default component.exports